import React from "react";
import { Button, Input, Alert, Form, Checkbox, Modal } from "antd";
import $ from "jquery";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "../static/css/login.css";
import ConfigGetter from "../utils/ConfigGetter";
import sha256 from "sha256";
import foreseem_logo from "../static/img/logo_white_foreseem.svg";

const cnf = ConfigGetter.getConfig();
/**
 * build login page
 */

// const {Tab, UserName, Password, Submit} = Login;

export default class LOGIN extends React.Component {
    constructor () {
        super();
        this.state = {
            autoLogin: true,
            wrongContent: "",
            password: undefined,
            rememberPwd: true,
            twoFA: false
        };
    }

    onChange (e) {
        if (e.target.checked) {
            this.setState({ rememberPwd: true });
        }
        else {
            this.setState({ rememberPwd: false });
        }
    }

    onSubmit () {
        this.state.wrongContent ? this.setState({ wrongContent: "" }) : this.state.wrongContent;

        let user_data = {};
        user_data["username"] = document.getElementById("username").value.replace(/(^\s*)|(\s*$)/g, "") || 'guest';
        user_data["password"] = sha256(document.getElementById("password").value.replace(/(^\s*)|(\s*$)/g, "")) || 'pass';
        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/login",
            data: user_data,
            success: (data) => {
                let result = JSON.parse(data);
                localStorage.setItem("user", result["user"]);
                localStorage.setItem("username", user_data["username"]);
                localStorage.setItem("avatar", result["avatar"] || "");
                localStorage.setItem("nickname", result["nickname"] || "");

                if (result["user"] !== "error" && result["user"] != null) {
                    this.state.password = user_data["password"];
                    if (result["2fa"] === true) {
                        this.setState({ twoFA: true });
                    }
                    else {
                        this.login();
                    }
                }
                else if (!data || result["user"] === "error") {
                    this.setState({
                        wrongContent: "Incorrect username or password."
                    });
                }
            },
            error: (data) => {
                console.log("error data: ", data);
                this.setState({
                    wrongContent: data && data.status === 401 ? "Incorrect username or password." : "Network failure or server error."
                });
            }
        });
    };

    login () {
        this.state.rememberPwd ? localStorage.setItem("password", this.state.password) : (sessionStorage.setItem("password", this.state.password));
        this.props.history.push("home");
        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/permission",
            success: (data) => {
                localStorage.setItem("permission", JSON.stringify(data));
            },
            error: (data) => {
                console.log("error data: ", data);
            }
        });
    }

    verify2FA () {
        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/2fa",
            data: {
                username: localStorage.getItem("username"),
                token: String(this.state.twoFA)
            },
            success: (data) => {
                if (JSON.parse(data)["success"] === true) {
                    this.login();
                }
                else {
                    this.setState({
                        twoFA: false,
                        wrongContent: "Invalid 2FA token."
                    });
                }
            },
            error: () => {
                this.setState({
                    twoFA: false,
                    wrongContent: "Network failure or server error."
                });
            }
        });
    }

    render () {
        return (
            // <div className={'aaa'} style={{marginTop: "12%"}}>
            <div className={"login-page"} style={{ marginTop: "0%" }}>
                <div className="login-warp" id="login" style={{ marginTop: "calc(6% + 180px)" }}>
                    <div className={"login-logo"}><a><img className={"foreseemLogo"} src={foreseem_logo}/></a></div>
                    <div className="overlay"></div>
                    <div>
                        {this.state.wrongContent && (
                            <Alert style={{ marginBottom: 24 }} message={this.state.wrongContent} type="error" showIcon
                                   closable
                                   onClose={() => this.setState({ wrongContent: "" })}/>
                        )}
                        <Form name="normal_login" className="login-warp" initialValues={{ remember: true, }}
                              onFinish={() => this.onSubmit()}>
                            <Form.Item name="username"
                                       rules={[{ required: true, message: "Please input your username" }]}>
                                <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="Username"
                                       id="username"/>
                            </Form.Item>
                            <Form.Item name="password"
                                       rules={[{ required: true, message: "Please input your password" }]}>
                                <Input prefix={<LockOutlined className="site-form-item-icon"/>} type="password"
                                       placeholder="Password" id="password"/>
                            </Form.Item>
                            <Form.Item name="remember">
                                <Checkbox defaultChecked={this.state.rememberPwd} onChange={(e) => this.onChange(e)}><a
                                    style={{ color: "#1890FF", fontFamily: "Montserrat, serif" }}>remember password</a></Checkbox>
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">Login</Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                <Modal title={"2FA"} visible={this.state.twoFA === true} width={400} centered={true}
                       onOk={() => this.verify2FA()} onCancel={() => this.setState({ twoFA: false })}
                       destroyOnClose={true} okText={"Confirm"}
                >
                    <Form className="two-fa">
                        <Form.Item label={"token"} name={"token"} rules={[{ required: true }]}>
                            <Input maxLength={6} minLength={6} autoFocus={true}
                                   onChange={(e) => {
                                       this.state.twoFA = e.target.value;
                                       String(e.target.value).length === 6 && this.verify2FA();
                                   }}/>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
            /*
                        <div style={{marginTop:"12%"}}>
                            {/!*<div className="login-warp" id="login" style={{marginTop: "15%", marginButton: "15%"}}>*!/}
                            <div className="login-warp" id="login" style={{marginTop: "100px"}}>

                            {/!*<img style={{backgroundImage: "pct" ,display: "block", margin: "0 auto"}}/>*!/}
                                <Login
                                    defaultActiveKey={this.state.type}
                                    // onTabChange={this.onTabChange}
                                    onSubmit={this.onSubmit}
                                >


                                    {/!*<Tab key="tab1" tab={<img id={"ant-tabs-no-animation"} src={logo} style={{width: "360px",height: "107px"}}/>} style={{fontSize: "35px"}}>*!/}
                                    <Tab key="tab1" tab={<h1 style={{font: "30px", color: "#FFFFFF", margin: "0 px", fontFamily: "Montserrat"}}>FORESEEM</h1>}
                                         style={{fontSize: "35px"}}>
                                        {this.state.wrongContent && (
                                            <Alert
                                                style={{marginBottom: 24}}
                                                message={this.state.wrongContent}
                                                type="error"
                                                showIcon
                                                closable
                                            />
                                        )}
                                        <UserName name="username" placeholder={"Username"} style={{minWidth: "125px",fontFamily:"Montserrat"}}/>
                                        <Password name="password" placeholder={"Password"} style={{minWidth: "125px",fontFamily:"Montserrat"}}/>
                                    </Tab>
                                    {/!*<Tab key="tab2" tab="Mobile">*!/}
                                    {/!*    <Mobile name="mobile" />*!/}
                                    {/!*    <Captcha onGetCaptcha={() => console.log('Get captcha!')} name="captcha" />*!/}
                                    {/!*</Tab>*!/}

                                    {/!*<div>*!/}
                                    {/!*    <Checkbox checked={this.state.autoLogin} onChange={this.changeAutoLogin}>*!/}
                                    {/!*        Keep me logged in*!/}
                                    {/!*    </Checkbox>*!/}
                                    {/!*    <a style={{ float: 'right' }} href="">*!/}
                                    {/!*        Forgot password*!/}
                                    {/!*    </a>*!/}
                                    {/!*</div>*!/}
                                    <Submit style={{fontFamily: "Montserrat"}}>Login</Submit>
                                </Login>
                            </div>
                        </div>
            */
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/Login.js